import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ProductSearchBar = ({ onSearch, onAdvancedSearch, searchTerm, setSearchTerm }) => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [advancedFilters, setAdvancedFilters] = useState({
    priceMin: '',
    priceMax: '',
    stockStatus: 'all',
    brand: '',
    sku: ''
  });

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  const handleAdvancedSearch = () => {
    onAdvancedSearch(advancedFilters);
    setShowAdvanced(false);
  };

  const handleAdvancedFilterChange = (field, value) => {
    setAdvancedFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const clearAdvancedFilters = () => {
    setAdvancedFilters({
      priceMin: '',
      priceMax: '',
      stockStatus: 'all',
      brand: '',
      sku: ''
    });
  };

  const stockStatusOptions = [
    { value: 'all', label: 'Todos los estados' },
    { value: 'in-stock', label: 'En stock' },
    { value: 'low-stock', label: 'Stock bajo' },
    { value: 'out-of-stock', label: 'Sin stock' }
  ];

  return (
    <div className="bg-surface rounded-lg border border-border p-4">
      {/* Basic Search */}
      <form onSubmit={handleSearch} className="mb-4">
        <div className="flex space-x-2">
          <div className="flex-1 relative">
            <Icon 
              name="Search" 
              size={20} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-muted"
            />
            <Input
              type="search"
              placeholder="Buscar productos por nombre, SKU o descripción..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
          <Button variant="primary" type="submit">
            Buscar
          </Button>
        </div>
      </form>

      {/* Advanced Search Toggle */}
      <div className="flex items-center justify-between">
        <button
          onClick={() => setShowAdvanced(!showAdvanced)}
          className="flex items-center space-x-2 text-sm text-primary hover:text-primary-700 font-body-medium"
        >
          <Icon name="Filter" size={16} />
          <span>Búsqueda avanzada</span>
          <Icon 
            name={showAdvanced ? 'ChevronUp' : 'ChevronDown'} 
            size={16} 
          />
        </button>
      </div>

      {/* Advanced Search Panel */}
      {showAdvanced && (
        <div className="mt-4 p-4 bg-secondary-50 rounded-lg border border-secondary-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-body-medium text-text-primary mb-2">
                SKU
              </label>
              <Input
                type="text"
                placeholder="Código SKU"
                value={advancedFilters.sku}
                onChange={(e) => handleAdvancedFilterChange('sku', e.target.value)}
              />
            </div>
            
            <div>
              <label className="block text-sm font-body-medium text-text-primary mb-2">
                Marca
              </label>
              <Input
                type="text"
                placeholder="Nombre de la marca"
                value={advancedFilters.brand}
                onChange={(e) => handleAdvancedFilterChange('brand', e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-body-medium text-text-primary mb-2">
                Precio mínimo (€)
              </label>
              <Input
                type="number"
                placeholder="0,00"
                value={advancedFilters.priceMin}
                onChange={(e) => handleAdvancedFilterChange('priceMin', e.target.value)}
                min="0"
                step="0.01"
              />
            </div>

            <div>
              <label className="block text-sm font-body-medium text-text-primary mb-2">
                Precio máximo (€)
              </label>
              <Input
                type="number"
                placeholder="999,99"
                value={advancedFilters.priceMax}
                onChange={(e) => handleAdvancedFilterChange('priceMax', e.target.value)}
                min="0"
                step="0.01"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-body-medium text-text-primary mb-2">
                Estado del stock
              </label>
              <select
                value={advancedFilters.stockStatus}
                onChange={(e) => handleAdvancedFilterChange('stockStatus', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
              >
                {stockStatusOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex items-center justify-end space-x-2">
            <Button variant="ghost" onClick={clearAdvancedFilters}>
              Limpiar filtros
            </Button>
            <Button variant="primary" onClick={handleAdvancedSearch}>
              Aplicar filtros
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductSearchBar;